import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    filter: null,
    claim: null,
    claims: null,
    replacementCost: null,
    deductibles: null,
    screenReplacementDeductible: -1,
    repairDeductible: -1,
    replacementDeductible: -1,
  },
  mutations: {
    ...mutations,
  },
  actions: {
    ...actions,
  },
  getters: {
    ...getters,
  },
}
